import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16.5 4l-4.5 8l-4.5 -8","key":"svg-0"}],["path",{"d":"M3 4l9 16l9 -16","key":"svg-1"}]]

const IconBrandVue = createReactComponent('outline', 'brand-vue', 'BrandVue', __iconNode);

export default IconBrandVue;